// ══════════════════════════════════════════════════════════════════════════════════════════════
//  EL PAÍS QUE SALE YA PUESTO EN UN TELÉFONO NUEVO  (t93, 5-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «Por defecto al crear un paciente o enviar un WhatsApp, que salga el +34 como prefijo». El campo del
//  teléfono con su país (components/CampoTelefono) enseña este país elegido cuando el campo está vacío y lo pone en
//  cuanto se empieza a escribir un número (salvo que el número ya lleve su «+» o su «00»). Es España, salvo que la
//  clínica diga otro país (clinicas.pais, que la configuración regional trae al cargar: context/RegionalContext lo
//  apunta aquí con `fijarPaisTelefonoClinica`) y ese país esté en la lista de prefijos.
//
//  Las pantallas públicas (el pre-registro, la derivación, el portal del paciente) no cargan la configuración de
//  ninguna clínica: ahí sale España.
//
//  Un `utils/` con un solo import de otro `utils/`: lo cargan de verdad las guardias que montan una pantalla, así que
//  meterlo en una no obliga a tocar cada guardia que la monta.
import { paisDeTelefono, aE164Declarado, motivoDeclarado } from './prefijosTelefono'
import { t as i18nT } from './i18n.js'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export const PAIS_TELEFONO_DEFECTO = 'ES'
let _paisClinica = null

const valido = (iso) => {
  const c = String(iso == null ? '' : iso).trim().toUpperCase()
  return /^[A-Z]{2}$/.test(c) && paisDeTelefono(c) ? c : null
}

/** Lo llama la configuración regional al cargarla (y con null al cerrar sesión). */
export function fijarPaisTelefonoClinica(iso) {
  _paisClinica = valido(iso)
}

/** El país que sale ya puesto en un teléfono nuevo: el de la clínica si lo tiene y está en la lista; si no, España. */
export function paisTelefonoPorDefecto() {
  return _paisClinica || PAIS_TELEFONO_DEFECTO
}

/** Un país por defecto que se le pasa a mano a un campo: solo si está en la lista de prefijos (si no, ninguno). */
export function paisPorDefectoValido(iso) {
  return valido(iso) || ''
}

/**
 * EL NÚMERO QUE SE MANDA desde un campo con su país donde se escribe a un número suelto («Nueva conversación» de
 * WhatsApp, la invitación al equipo). Con España, sin país o con el número ya con su `+`/`00`: TAL CUAL lo escribió la
 * persona (lo de siempre: el servidor lo normaliza igual que hoy). Con otro país elegido: con su prefijo delante
 * («+353 …» compuesto), que es lo único que ningún camino puede leer como español; si con ese país no se compone, el
 * porqué. → { telefono } o { error }. `minimo9`: el mínimo de nueve cifras que ya pedía «Nueva conversación».
 */
export function telefonoConSuPais(texto, pais, { minimo9 = false } = {}) {
  const t = String(texto == null ? '' : texto).trim()
  if (!t) return { telefono: '' }
  const p = valido(pais)
  if (!p || p === 'ES' || /^(\+|00)/.test(t)) {
    if (minimo9 && t.replace(/\D/g, '').length < 9) return { error: i18nT('utils.paisTelefonoClinica.introduce_un_telefono_valido_minimo', 'Introduce un teléfono válido (mínimo 9 dígitos)') }
    return { telefono: t }
  }
  const e = aE164Declarado(t, p)
  if (!e) return { error: motivoDeclarado(t, p) || i18nT('utils.paisTelefonoClinica.ese_numero_no_encaja_con', 'Ese número no encaja con el país elegido.') }
  return { telefono: '+' + e }
}
